// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


	// Mobile Menu Functionality
	if(document.getElementById("header")){
		let menuContent = document.getElementById("menuContainer");
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-show_nav]");
		let closeBtn = document.querySelector("[data-close_nav]");
		// Show
		if(menuBtn){
			menuBtn.addEventListener('click', function (e) {
				menuContent.classList.add("open");
				header.classList.add("menuOpen");
				document.querySelector("body").classList.add("no-scroll");
			});
		}
		// Close
		if(menuBtn){
			closeBtn.addEventListener('click', function (e) {
				menuContent.classList.remove("open");
				header.classList.remove("menuOpen");
				document.querySelector("body").classList.remove("no-scroll");
			});
		}
	}


    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.querySelector('.highlights')){
		let tabsAccordion = document.querySelectorAll('.highlights__tab');
		let itemsAccordion = document.querySelectorAll('.highlights__item');
		let contentAccordion = document.querySelectorAll('.highlights__content .highlights__image, .highlights__content .highlights__text');

		tabsAccordion.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let data = tab.dataset.entry;
				itemsAccordion.forEach((item)=>{
					item.classList.toggle('active', item.dataset.entry == data);
				});
				contentAccordion.forEach((content)=>{
					setTimeout(() => {
						content.classList.toggle('hidden', content.dataset.entry != data);
					}, 200);
				})
			})
		})
	}

	// WRAP MODULE TABLES
	document.querySelectorAll('.form-module-wrapper').forEach((form) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('form-module-wrapper__container','animate-fade','top');
        let confirmation = form.querySelector('.form-module__confirmation');
        let contentForm = form.querySelector('.form-module');
        form.appendChild(tableWrapper);
        tableWrapper.appendChild(confirmation);
        tableWrapper.appendChild(contentForm);
	});

	// problems for uploading forms
	let allForms = document.querySelectorAll('.form-module');

	allForms.forEach((form)=>{
		setTimeout(() => {
			form.classList.add('loading');
		}, 2000);
	})



})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}